import { createSelector } from 'reselect';

// STATE SELECTORS
const breadcrumb = state => state.admin.breadcrumb;

export const breadcrumbSetSelector = createSelector(breadcrumb, bc => bc.set);
export const breadcrumbSelector = createSelector(breadcrumb, bc => bc.locations);



// WEBPACK FOOTER //
// ./src/selectors/admin/breadcrumb.js